import { observer } from 'mobx-react-lite'
import React from 'react'
import classNames from 'classnames'
import { Button } from 'shared/ui'
import { LINK_REFERRALS_PARTNERS, LINK_REFERRALS_PARTNERSTACK } from 'shared/constants/links'
import styles from './styles.module.scss'

export const ReferralsActions = observer(() => {
  return (
    <div className={classNames(styles.actionsContainer)}>
      <Button
        tag='a'
        text='Start referring'
        size='medium'
        className={styles.actionButton}
        href={LINK_REFERRALS_PARTNERSTACK}
        target='_blank'
        rel='noreferrer'
      />
      <Button
        tag='a'
        text='Program overview'
        size='medium'
        contained='secondary'
        iconProps={{ icon: 'info' }}
        className={classNames(styles.helpButton)}
        href={LINK_REFERRALS_PARTNERS}
        target='_blank'
        rel='noreferrer'
      />
    </div>
  )
})
